import {RingGame} from './data/LobbyData'

interface StakeDetails {
    name: string,
    tableCount: number,
    totalHph: number
}


export const getQuickSeatStakes = (games: RingGame[]) => {
	const stakes = new Set<string>()
	const details = new Map<String, StakeDetails>()

	games.filter(g => g.isQuickSeatTable)
		.map(g => {
			return {
				type: g.type,
				variant: g.variant,
				capacity: g.capacity,
				smallBlind: g.smallBlind,
				bigBlind: g.bigBlind,
				currencyCode: g.currencyCode,
				minBuyIn: g.minBuyIn,
				maxBuyIn: g.maxBuyIn,
				isQuickSeat: true,
				name: g.name,
				handsPerHour: g.handsPerHour,
			}
		})
		.forEach(g => {
			const {name, handsPerHour, ...level} = g
			const key = JSON.stringify(level)
			// this makes the name configurable by PRM; they should only provide 1 name, but incase it will take the last name it sees
			const current = details.has(key) ? details.get(key) : {name: g.name, tableCount: 0, totalHph: 0}
			details.set(key, {
				name: current.name,
				tableCount: current.tableCount+1,
				totalHph: current.totalHph+g.handsPerHour
			})
			stakes.add(key)
		})


	// negative ids so no collision with tables
	let stakeCount = 0
	return Array.from(stakes.values())
		.map(g => {
			const parsed = JSON.parse(g)
			const stakeDetail = details.get(g)
			parsed.name = stakeDetail.name
			parsed.handsPerHour = (stakeDetail.totalHph / stakeDetail.tableCount).toFixed(2)
			return parsed
		})
		.map(g => {
			g.ante = 0
			g.seated = 0
			g.level = 0
			g.averagePot = 0
			g.flopsSeen = 0
			g.isQuickSeat = true
			g.id = --stakeCount
			return g
		})
}
